import actions from './actions'

const initialState = {
  id: '',
  name: '',
  roles: [],
  number: '',
  email: '',
  organization: '',
  designation: '',
  avatarType: 'text',
  avatarData: '',
  avatarColor: '',
  mode: 'email',
  authorized: false,
  loading: false,
  loginStatus: '',
  accessToken: '',
  tokenType: '',
  assignedScene: [],
}

export default function virtualuserReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
